module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_okunai-01662560d12731ff94cfea329fe97ef2.webp";